import { render, staticRenderFns } from "./SaveThePlanet.vue?vue&type=template&id=e96a4598&scoped=true&"
import script from "./SaveThePlanet.vue?vue&type=script&lang=js&"
export * from "./SaveThePlanet.vue?vue&type=script&lang=js&"
import style0 from "./SaveThePlanet.vue?vue&type=style&index=0&id=e96a4598&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96a4598",
  null
  
)

component.options.__file = "SaveThePlanet.vue"
export default component.exports